module.exports = __webpack_public_path__ + "img/logo.899a8adf.png";